module.exports = __webpack_public_path__ + "media/images/avatar-15-1-61f538b4f6b22daedc2773bcbe505335.svg";